import React from "react";
import "./home.css";

export default function HomeBrands() {
  return (
    <section className="section-wrap brands-slider nopadding">
      <div className="container">
        <div className="row brands-wrap">
          <div className="col-xs-6 col-md-3 col-lg-2">
            <img
              className="m-auto"
              src="/assets/img/sf/partner/SF_EX_WH_2.png"
              alt="SF_EX_WH_2"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
